/// MOBILE NAVIGATION ///
const mobileMenuToggle = document.getElementById("mobileToggle");

mobileMenuToggle.addEventListener('click', (event) => {
    const navBar = document.getElementById("nav-bar");

    if ( navBar )
        navBar.classList.toggle("open");
});

/// PRODUCTS SWITCH GIFTS ///

// JavaScript
const giftLink = document.querySelector("#gift-link");

giftLink.addEventListener("click", (event) => {
    
    const toggleGiftProducts = document.getElementById("giftBtn");

    if ( document.getElementById("label-me").classList.contains("active") ) {
        toggleGiftProducts.click();
    }
    
});


const toggleGiftProduct = document.getElementById("giftBtn");

let giftBundleLabel = document.getElementById("label-me");
if (giftBundleLabel) {
    giftBundleLabel.classList.add('active'); //default active on for me
}
let isGift = false;

if (toggleGiftProduct) {
    toggleGiftProduct.addEventListener('click', (event) => {
        toggleGiftProduct.classList.toggle("on");

        document.getElementById("label-me").classList.toggle("active");
        document.getElementById("label-gift").classList.toggle("active");

        // document.getElementById("plant-now").classList.toggle("hide"); //button label
        // document.getElementById("gift-bundle").classList.toggle("hide"); //button lable

        const plantNowButtons = document.querySelectorAll('.plant-now');
        plantNowButtons.forEach(button => {
            button.classList.toggle('hide')
        });

        const giftBundleButtons = document.querySelectorAll('.gift-bundle');
        giftBundleButtons.forEach(button => {
            button.classList.toggle('hide')
        });


        const giftLinks = document.querySelectorAll('.plant-gift-button');
        giftLinks.forEach(link => {
            const hrefValue = link.getAttribute("href");

            if (hrefValue.includes("is_gift")) {
                const cleanValue = hrefValue.split('?')[0];
                link.href = cleanValue;
            } else {
                link.href = hrefValue + '?is_gift=true';
            }
        })


        isGift = !isGift

    });
}

//Home page landing gift products
if (window.location.href.includes("#products")) {

    if (window.location.href.includes('#products?gift')) {
        const giftButton = document.getElementById("giftBtn");
        if (giftButton) {
            giftButton.click();
        }
    }

}


//HOME PRODUCT PAGE CLICK

if (window.location.href.includes('/products')) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has('is_gift')) {
    const isGiftProduct = document.getElementById('isGiftCheck');

    if (isGiftProduct) {

        isGiftProduct.click();

        document.getElementById('product_type').value = "gift"
        document.getElementById("gift-form").classList.toggle("hidden");

        document.getElementById("how-it-works-schedule").classList.add("hidden"); //hide schedule cert form

        document.getElementById("add-cart-btn-container").classList.toggle("hidden"); //Hide plant now if gift
    }
  }
}


/// PRODUCT IS GIFT TOGGLE SWITCH ///
let isProductGift = false;
const isGiftProduct = document.getElementById('isGiftCheck');

if ( isGiftProduct ) {
    isGiftProduct.addEventListener('change', function() {
        if (this.checked) {
            document.getElementById('product_type').value = "gift"
            document.getElementById("gift-form").classList.toggle("hidden");

            document.getElementById("add-cart-btn-container").classList.toggle("hidden"); //Hide plant now if gift
        } else {
            document.getElementById('product_type').value = "personal"
            document.getElementById("gift-form").classList.toggle("hidden");

            document.getElementById("add-cart-btn-container").classList.toggle("hidden"); //Remove plant now if gift
        }
    });
}


/// PRODUCT DELIVERY METHO ///
const scheduleDeliveryBtn = document.getElementById("gift-delivery-schedule");
const scheduleNowBtn = document.getElementById("gift-delivery-now");
const deliveryDateInput = document.getElementById("gift-delivery-date");
const deliveryTimeInput = document.getElementById("gift-delivery-time");
const deliveryTimeList = document.getElementById('times');


// Get the current date and time

if (deliveryDateInput) {
    const now = new Date();
    now.setHours(now.getHours() + 1, 0, 0, 0) //to move to one hour ahead a minimum.

    // Adjust for local timezone offset to get correct local ISO string
    const offset = now.getTimezoneOffset() * 60000;

    const localISOTime = new Date(now.getTime() - offset)
        .toISOString()
        .slice(0, 10); // Extracts 'YYYY-MM-DDTHH:MM'
    // Set the minimum selectable date/time [to fix]

    deliveryDateInput.value = localISOTime; //default value
    deliveryDateInput.min = localISOTime;
    // deliveryDateInput.step = 900;

    deliveryDateInput.addEventListener("change", (event) => {
        deliveryDateInput.value = `${event.target.value}`;

        //clear time to validate everything.
        deliveryTimeInput.value = "";
    });
}

if (deliveryTimeInput) {
    const d = new Date();
    d.setHours(d.getHours() + 1, 0, 0, 0) //to move to one hour ahead a minimum.

    let hour = d.getHours();

    document.getElementById("gift-delivery-time").value = `${hour}:00`;

    document.getElementById("gift-delivery-time").addEventListener("click", function(){

        //if delivery date is not today
        const today = new Date().toISOString().slice(0, 10);

        var options = '';

        if ( deliveryDateInput.value == today ) {
            for (var i = hour; i < 24; i++) {
                options += '<option value="' + i + ':00' + '" />';
            }

            if (deliveryTimeList) {
                deliveryTimeList.innerHTML = options;
            }
        } else {
            for (var i = 0; i < 24; i++) {
                options += '<option value="' + i + ':00' + '" />';
            }

            if (deliveryTimeList) {
                deliveryTimeList.innerHTML = options;
            }
        }



    });
}

const howItWorksNotification = document.getElementById("how-it-works-schedule")


if ( scheduleDeliveryBtn || scheduleNowBtn ) {
    scheduleDeliveryBtn.addEventListener("click", (event) => {
        event.preventDefault();
        scheduleNowBtn.classList.remove("active");
        scheduleDeliveryBtn.classList.add("active");
        deliveryDateInput.classList.remove("hidden");
        deliveryTimeInput.classList.remove("hidden");

        document.getElementById("gift-delivery-now-value").value = ""; //schedule to send now

        //document.getElementById("how-it-works-now").classList.toggle("hidden");
        //document.getElementById("how-it-works-schedule").classList.add("hidden");

        document.getElementById("how-it-works-now").style.display = "none";
        document.getElementById("how-it-works-schedule").style.display = "";

        //howItWorksNotification.innerHTML = "<strong>So funktioniert's: </strong>Die beschenkte Person erhält das Zertifikat per E-Mail am von dir gewählten Datum. Du bekommst zeitgleich eine Kopie, damit du genau weißt, was sie sieht.";
    })

    scheduleNowBtn.addEventListener("click", (event) => {
        event.preventDefault();
        deliveryDateInput.classList.toggle("hidden");
        deliveryTimeInput.classList.toggle("hidden");
        scheduleNowBtn.classList.toggle("active");
        scheduleDeliveryBtn.classList.toggle("active");

        document.getElementById("gift-delivery-now-value").value = "now"; //schedule to send now
        
        //set time of time to the input
        //set auto via js.

        //document.getElementById("how-it-works-now").classList.add("hidden");
        //document.getElementById("how-it-works-schedule").classList.toggle("hidden");

        document.getElementById("how-it-works-now").style.display = "";
        document.getElementById("how-it-works-schedule").style.display = "none"; //remove style

        //howItWorksNotification.innerHTML = "<strong>So funktioniert's: </strong>Nach dem Kauf erhält die beschenkte Person das Zertifikat sofort per E-Mail. Du bekommst ebenfalls eine Kopie."
    })
}

// FAQ SCRIPTS ///
const faqButtons = document.querySelectorAll('.faq-q');
faqButtons.forEach(faq => {
    faq.addEventListener('click', (event) => {
        faq.parentElement.classList.toggle("open");
    })
});


//LINKS TO NEW TAB

(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
})();